import * as React from 'react';
import { Fragment, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { TimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from "moment";

interface ITimeRangeFilterProps {
    setFilterValue: (filter: string, value: string) => void;
    filterNames: string[];
    startValue: string;
    endValue: string;
    applied: boolean;
    unmarkApplied: (filter: string) => void;
    displayName: string;
}

export default function TimeRangeFilter(props: ITimeRangeFilterProps) {
    const [startTime, setStartTime] = useState<any>(moment());
    const [endTime, setEndTime] = useState<any>(moment());

    useEffect(() => {
        if (props.startValue) {
            let start = moment()
            let startNums = props.startValue.split(':');
            const startHour = parseInt(startNums[0])
            const startMin = parseInt(startNums[1])
            start.hour(startHour);
            start.minute(startMin);
            setStartTime(start);
        }
        if (props.endValue) {
            let end = moment()
            let endNums = props.endValue.split(":");
            const endHour = parseInt(endNums[0])
            const endMin = parseInt(endNums[1])
            end.hour(endHour);
            end.minute(endMin);
            setEndTime(end);
        }
    }, [])
    const handleClick = () => {
        props.unmarkApplied(props.displayName);
    }
    const onStartChanged = (value: moment.Moment) => {
        let newTime = value.clone();
        if (newTime !== null) {
            if (newTime.minute() > 0 && newTime.minute() < 15) {
                newTime.minute(0);
            }
            if (newTime.minute() > 15 && newTime.minute() < 30) {
                newTime.minute(15);
            }
            if (newTime.minute() > 30 && newTime.minute() < 45) {
                newTime.minute(30);
            }
            if (newTime.minute() > 45) {
                newTime.minute(45);
            }
        }
        setStartTime(newTime)
        console.log(newTime.format("HH:mm"));
        props.setFilterValue(props.filterNames[0], newTime.format("HH:mm"));
    }

    const onEndChanged = (value: moment.Moment) => {
        let newTime = value.clone();
        if (newTime !== null) {
            if (newTime.minute() > 0 && newTime.minute() < 15) {
                newTime.minute(0);
            }
            if (newTime.minute() > 15 && newTime.minute() < 30) {
                newTime.minute(15);
            }
            if (newTime.minute() > 30 && newTime.minute() < 45) {
                newTime.minute(30);
            }
            if (newTime.minute() > 45) {
                newTime.minute(45);
            }
        }
        setEndTime(newTime)

        props.setFilterValue(props.filterNames[1], newTime.format("HH:mm"));
    }

    return (

        props.applied ?
            <Fragment>
                <Grid style={{ paddingRight: '8px' }} onClick={handleClick}>
                    <Typography variant="body1">is between {props.startValue} and {props.endValue}</Typography>
                </Grid>
            </Fragment>
            :
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <Fragment>
                    <Grid style={{ paddingRight: '8px' }}>
                        <Typography variant="body1">from</Typography>
                    </Grid>
                    <Grid>
                        <TimePicker
                            value={startTime}
                            onChange={(newDate: moment.Moment) => onStartChanged(newDate)}
                            ampm={false}
                            minutesStep={15}
                            skipDisabled
                            sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '110px' }}
                        />
                    </Grid>
                    <Grid style={{ padding: '0 8px' }}>
                        <Typography variant="body1">to</Typography>
                    </Grid>
                    <Grid>
                        <TimePicker
                            value={endTime}
                            onChange={(newDate: moment.Moment) => onEndChanged(newDate)}
                            ampm={false}
                            minutesStep={15}
                            skipDisabled
                            sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '110px' }}
                        />
                    </Grid>
                </Fragment>
            </LocalizationProvider>



    )


}
